import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/attention_rounded_blue.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-41ad3714")

_pushScopeId("data-v-41ad3714")
const _hoisted_1 = {
  key: 0,
  class: "attention",
  src: _imports_0
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_notification_icon = _resolveComponent("notification-icon")
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_header_feven = _resolveComponent("header-feven")
  const _component_finder_matches = _resolveComponent("finder-matches")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_header_feven, { white: false }, {
      left: _withId(() => [
        _createVNode(_component_notification_icon)
      ]),
      right: _withId(() => [
        _createVNode("div", {
          class: "filter_container",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFilter()))
        }, [
          (_ctx.filter.currentPosition.addressFixed || _ctx.filter.findUserOutsideMyRange)
            ? (_openBlock(), _createBlock("img", _hoisted_1))
            : _createCommentVNode("", true),
          _createVNode(_component_localized_text, {
            class: "fev_text5 fw_700",
            localizedKey: "app_Filtri",
            text: "Filtri"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode("div", null, [
      _createVNode(_component_finder_matches, {
        onOpenFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilter())),
        onOpenDescription: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDescription())),
        onOpenExperienceList: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openExperienceList())),
        onNext: _cache[5] || (_cache[5] = ($event: any) => (_ctx.next())),
        onReplyToMatch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reply(_ctx.match.matchIdentifier))),
        onCreateChatCheck: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createChatCheck(_ctx.match.matchIdentifier))),
        onViewQuestionAndAnswers: _cache[8] || (_cache[8] = ($event: any) => (_ctx.viewQuestionAndAnswers(_ctx.match.matchIdentifier))),
        onGetNewMatch: _ctx.getNewMatch,
        match: _ctx.match,
        filter: _ctx.filter
      }, null, 8, ["onGetNewMatch", "match", "filter"])
    ])
  ], 64))
})